import React from "react";
import { DropdownButton } from "../Button";

import { connect } from "react-redux";
import transactionSubType from "../../constants/transactionSubType";
import { Checkbox } from "../Input";
import { onAddFilter } from "../../actions/Filters";

class TransactionSubType extends React.Component {
  onCheck(el) {
    let { filters } = this.props;
    let { transactionSubType = [] } = filters;

    const index = transactionSubType.findIndex((sEl) => sEl.value === el.value);

    if (index === -1) {
      transactionSubType = [el];
    } else {
      transactionSubType.splice(index, 1);
    }

    this.props.dispatch(
      onAddFilter({
        transactionSubType,
      })
    );
  }
  render() {
    return (
      <DropdownButton
        leftIcon={this.props.icon}
        text={this.props.title}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.props?.filters?.transactionSubType}
        clickOutside
      >
        {transactionSubType.map((el, i) => {
          return (
            <Checkbox
              label={el.label}
              key={i}
              onCheck={() => this.onCheck(el)}
              checked={this.props?.filters?.transactionSubType?.find(
                (sEl) => sEl.value === el.value
              )}
            />
          );
        })}
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(TransactionSubType);
